export type SelectorCategory = 'customer' | 'method' | 'time' | 'zone';
